module.exports = __webpack_public_path__ + "media/images/im-an-employee-home-f05be3b6.jpg";